<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 13:13:40
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-17 10:54:16
 -->
<template>
  <div id="layout">
    <div class="headerContainer">
      <Header />
    </div>
    <div class="contentContainer">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'Layout',
  components: {
    Header,
  },
}
</script>

<style lang="less" scoped>
#layout {
  width: 100%;
  height: 100vh;
  min-width: 1920px;
  min-height: 960px;
  background: url('/static/img/layout/bg.png');
  background-size: 100% 100%;
  .headerContainer {
    width: 100%;
    height: 6%;
  }
  .contentContainer {
    width: 100%;
    height: 94%;
  }
}
</style>
